import React from "react";
import {SectionTitle} from "../sectionTitle";

export const Olapic = ({items}) => {
    return (
        <div className="olapic-container">
            <SectionTitle title="Bienvenue chez vous !" fancy="true"/>
            <p className="olapic-subtitle text-center">
                Inspirez-vous des plus beaux intérieurs de notre communauté{" "}
                <span className="olapic-subtitle-highlight">@BUT</span>
            </p>
            <ul className="olapic-list">
                {items.map(({imageUrl, username}, index) => {
                    return (
                        <li className="olapic-item" key={index}>
                            <div className="olapic-inner">
                                <img
                                    className="olapic-image"
                                    srcSet={`${imageUrl} 320w, ${imageUrl} 640w`}
                                    sizes="(min-width: 1025px) 25vw, 50vw"
                                    src={imageUrl}
                                    alt={username}
                                    width={392}
                                    height={392}
                                    loading={"lazy"}
                                />
                                <span className="olapic-username">{username}</span>
                            </div>
                        </li>
                    );
                })}
            </ul>
            <div className="text-center">
                <a
                    className="olapic-link button primary medium"
                    href="https://www.but.fr/galerie-photo-bienvenue-chez-vous"
                >
                    Découvrez la galerie
                </a>
            </div>
        </div>
    );
};
